import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="tooltip"
export default class TooltipController extends Controller {
  connect() {
    // Don't enable tooltips on mobile devices
    if (!globalThis.AppConfig.isDesktop) return

    document.addEventListener('click', this.closeTooltip)

    $('.tooltip').remove()

    this.tooltip = new bootstrap.Tooltip(this.element, {
      boundary: document.body,
      sanitize: false
    })
  }

  disconnect() {
    if (!globalThis.AppConfig.isDesktop) return

    document.removeEventListener('click', this.closeTooltip)

    if (this.tooltip) {
      this.tooltip.dispose()
    }
  }

  closeTooltip = () => {
    this.tooltip?.hide()
  }
}
